module.exports = __webpack_public_path__ + "img/Синдром грушевидной мышцы.ba635357.jpg";